document.addEventListener('DOMContentLoaded', () => {
  // Initialize the Design Yours section
  const initDesignYours = () => {
    const sections = document.querySelectorAll('.comp-design-yours');
    
    if (!sections.length) return;
    
    sections.forEach(section => {
      // Handle video elements to ensure proper autoplay
      const videos = section.querySelectorAll('.comp-design-yours__video');
      
      videos.forEach(video => {
        // Ensure videos are muted for autoplay
        video.muted = true;
        
        // Attempt to play the video
        const playVideo = () => {
          video.play().catch(error => {
            console.log('Video autoplay failed:', error);
          });
        };
        
        // Play video when it's loaded
        if (video.readyState >= 3) {
          playVideo();
        } else {
          video.addEventListener('loadeddata', playVideo);
        }
        
        // Restart video when it ends (for loop)
        video.addEventListener('ended', () => {
          video.currentTime = 0;
          playVideo();
        });
      });
      
      // Handle responsive behavior if needed
      const handleResize = () => {
        // Add any specific resize handling if needed
      };
      
      // Initial call
      handleResize();
      
      // Listen for resize events
      window.addEventListener('resize', handleResize);
    });
  };
  
  // Initialize the section
  initDesignYours();
  
  // Handle theme editor changes
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.comp-design-yours')) {
        initDesignYours();
      }
    });
  }
});